import { __decorate, __metadata, __param } from "tslib";
import { E_TASK_STATUS } from '@/apis/service/workspace/WorkspaceApi.types';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let TaskCentersService = class TaskCentersService {
    constructor(workspaceApi, authService) {
        this.workspaceApi = workspaceApi;
        this.authService = authService;
    }
    postTaskAdminQuery(params) {
        return this.workspaceApi.postTaskAdminQuery(params);
    }
    putCancelTask(params) {
        return this.workspaceApi.putCancelTask(this.authService.currentUser?.id, [params]);
    }
    /**
     * 是否显示取消
     */
    showCancel(row) {
        return row.status_code === E_TASK_STATUS.TATUS_READY;
    }
};
TaskCentersService = __decorate([
    injectable(),
    __param(0, inject(Symbols.WorkspaceApi)),
    __param(1, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object])
], TaskCentersService);
export { TaskCentersService };
